'use strict';

document.addEventListener('DOMContentLoaded', () => {
    const clickableImageClass = '.js-image-container';
    const clickableImageElement = document.querySelector(clickableImageClass);
    // Load the JS only if the particular elment is present
    if (clickableImageElement) {
        const { handleImageContainerClick } = require('./experience/components/commerce_assets/helper/clickableBannerImagesHelper');
        handleImageContainerClick(clickableImageClass);
    }

    const videoControlsClass = '.js-video-clickable-container';
    const videoControlsElements = document.querySelectorAll(videoControlsClass);
    // Load the JS only if the particular elment is present
    if (videoControlsElements && videoControlsElements.length) {
        const { videoControlsHelper } = require('./experience/components/commerce_assets/helper/videoControls.js')
        videoControlsElements.forEach(component => videoControlsHelper(component));
    }

    const imageChangeOnhoverClass = '.js-image-banner';
    const imageChangeOnhoverElement = document.querySelector(imageChangeOnhoverClass);
    // Load the JS only if the particular elment is present
    if (imageChangeOnhoverElement) {
        const { imageChangeOnhover } = require('./experience/components/commerce_assets/helper/imageChangeOnhover.js')
        imageChangeOnhover(imageChangeOnhoverClass);
    }
});
